import { createRouter, createWebHistory, useRouter } from 'vue-router'
import { getStorage } from '@/utils/storage'
import titleList from '@/lang/title'
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/home.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue')
  },
  //个人中心
  {
    path: '/mine/mineUserInfo',
    name: 'mineUserInfo',
    component: () => import(/* webpackChunkName: "login" */ '@/views/mine/mineUserInfo.vue'),
  },
  //用户管理
  {
    path: '/users/userList',
    name: 'userList',
    component: () => import(/* webpackChunkName: "userList" */ '@/views/users/userList.vue'),

  },
  {
    path: '/users/userLogsManage',
    name: 'userLogsManage',
    component: () => import(/* webpackChunkName: "userLogsManage" */ '@/views/users/userLogsManage.vue'),

  },
  {
    path: '/users/userPortraitList',
    name: 'userPortraitList',
    component: () => import(/* webpackChunkName: "userPortraitList" */ '@/views/users/userPortraitList.vue'),

  },
  {
    path: '/users/userGroup',
    name: 'userGroup',
    component: () => import(/* webpackChunkName: "userGroup" */ '@/views/users/userGroup.vue'),

  },
  {
    path: '/users/userBlack',
    name: 'userBlack',
    component: () => import(/* webpackChunkName: "userBlack" */ '@/views/users/userBlack.vue'),

  },
  {
    path: '/users/otherBlack',
    name: 'otherBlack',
    component: () => import(/* webpackChunkName: "otherBlack" */ '@/views/users/otherBlack.vue'),

  },
  {
    path: '/users/userOnline',
    name: 'userOnline',
    component: () => import(/* webpackChunkName: "userOnline" */ '@/views/users/userOnline.vue'),

  },
  {
    path: '/users/userAmountLog',
    name: 'userAmountLog',
    component: () => import(/* webpackChunkName: "userAmountLog" */ '@/views/users/userAmountLog.vue'),

  },
  {
    path: '/users/userFileAmountLog',
    name: 'userFileAmountLog',
    component: () => import(/* webpackChunkName: "userFileAmountLog" */ '@/views/users/userFileAmountLog.vue'),

  },
  {
    path: '/users/userForbidden',
    name: 'userForbidden',
    component: () => import(/* webpackChunkName: "userForbidden" */ '@/views/users/userForbidden.vue'),
  },
  //游戏管理
  {
    path: '/games/gameClassify',
    name: 'gameClassify',
    component: () => import(/* webpackChunkName: "gameClassify" */ '@/views/games/gameClassify.vue'),

  },
  {
    path: '/games/gameManage',
    name: 'gameManage',
    component: () => import(/* webpackChunkName: "gameManage" */ '@/views/games/gameManage.vue'),

  },
  {
    path: '/games/gameFishManage',
    name: 'gameFishManage',
    component: () => import(/* webpackChunkName: "gameFishManage" */ '@/views/games/gameFishManage.vue'),

  },
  {
    path: '/games/gameFishControl',
    name: 'gameFishControl',
    component: () => import(/* webpackChunkName: "gameFishControl" */ '@/views/games/gameFishControl.vue'),

  },
  {
    path: '/games/gameRobotData',
    name: 'gameRobotData',
    component: () => import(/* webpackChunkName: "gameRobotData" */ '@/views/games/gameRobotData.vue'),

  },
  {
    path: '/games/gameOdds',
    name: 'gameOdds',
    component: () => import(/* webpackChunkName: "gameOdds" */ '@/views/games/gameOdds.vue'),

  },
  {
    path: '/games/gameQuota',
    name: 'gameQuota',
    component: () => import(/* webpackChunkName: "gameQuota" */ '@/views/games/gameQuota.vue'),

  },
  {
    path: '/games/gameBlack',
    name: 'gameBlack',
    component: () => import(/* webpackChunkName: "gameBlack" */ '@/views/games/gameBlack.vue'),

  },

  //开奖管理
  {
    path: '/open/openHistory',
    name: 'openHistory',
    component: () => import(/* webpackChunkName: "openHistory" */ '@/views/open/openHistory.vue'),
  },
  //订单管理
  {
    path: '/orders/orderList',
    name: 'orderList',
    component: () => import(/* webpackChunkName: "orderList" */ '@/views/orders/orderList.vue'),
  },
  {
    path: '/orders/fileList',
    name: 'fileList',
    component: () => import(/* webpackChunkName: "fileList" */ '@/views/orders/fileList.vue'),
  },
  //运营管理
  {
    path: '/operate/prizeControl',
    name: 'prizeControl',
    component: () => import(/* webpackChunkName: "prizeControl" */ '@/views/operate/operatePrizeControl.vue'),
  },
  {
    path: '/operate/gameWinRateConfig',
    name: 'gameWinRateConfig',
    component: () => import(/* webpackChunkName: "gameWinRateConfig" */ '@/views/operate/gameWinRateConfig.vue'),
  },
  {
    path: '/operate/userControl',
    name: 'userControl',
    component: () => import(/* webpackChunkName: "userControl" */ '@/views/operate/userControl.vue'),
  },
  {
    path: '/operate/rollList',
    name: 'rollList',
    component: () => import(/* webpackChunkName: "rollList" */ '@/views/operate/rollList.vue'),
  },
  {
    path: '/operate/gameJackPotDatas',
    name: 'gameJackPotDatas',
    component: () => import(/* webpackChunkName: "gameJackPotDatas" */ '@/views/operate/gameJackPotDatas.vue'),

  },
  //消息通知
  {
    path: '/notice/platformNotice',
    name: 'platformNotice',
    component: () => import(/* webpackChunkName: "platformNotice" */ '@/views/notice/platformNotice.vue'),
  },
  //轮播广告
  {
    path: '/notice/adSet',
    name: 'adSet',
    component: () => import(/* webpackChunkName: "adSet" */ '@/views/notice/adSet.vue'),
  },

  //数据报表
  {
    path: '/datas/gameReport',
    name: 'gameReport',
    component: () => import(/* webpackChunkName: "gameReport" */ '@/views/datas/gameReport.vue'),
  },
  {
    path: '/datas/platformReport',
    name: 'platformReport',
    component: () => import(/* webpackChunkName: "platformReport" */ '@/views/datas/platformReport.vue'),
  },
  {
    path: '/datas/userReport',
    name: 'userReport',
    component: () => import(/* webpackChunkName: "userReport" */ '@/views/datas/userReport.vue'),
  },
  {
    path: '/datas/cashReport',
    name: 'cashReport',
    component: () => import(/* webpackChunkName: "cashReport" */ '@/views/datas/cashReport.vue'),
  },
  {
    path: '/datas/settlementReport',
    name: 'settlementReport',
    component: () => import(/* webpackChunkName: "settlementReport" */ '@/views/datas/settlementReport.vue'),
  },
  {
    path: '/datas/gameUserReport',
    name: 'gameUserReport',
    component: () => import(/* webpackChunkName: "gameUserReport" */ '@/views/datas/gameUserReport.vue'),
  },
  {
    path: '/datas/activityReport',
    name: 'activityReport',
    component: () => import(/* webpackChunkName: "activityReport" */ '@/views/datas/activityReport.vue'),
  },
  //系统管理
  {
    path: '/systems/systemUserManage',
    name: 'systemUserManage',
    component: () => import(/* webpackChunkName: "systemUserManage" */ '@/views/systems/systemUserManage.vue'),
  },
  {
    path: '/systems/systemRoleManage',
    name: 'systemRoleManage',
    component: () => import(/* webpackChunkName: "systemRoleManage" */ '@/views/systems/systemRoleManage.vue'),
  },
  {
    path: '/systems/systemPlatformManage',
    name: 'systemPlatformManage',
    component: () => import(/* webpackChunkName: "systemPlatformManage" */ '@/views/systems/systemPlatformManage.vue'),
  },
  {
    path: '/systems/systemPlatformWhiteSetting',
    name: 'systemPlatformWhiteSetting',
    component: () => import(/* webpackChunkName: "systemPlatformManage" */ '@/views/systems/systemPlatformWhiteSetting.vue'),
  },
  {
    path: '/systems/systemPlatformLogs',
    name: 'systemPlatformLogs',
    component: () => import(/* webpackChunkName: "systemPlatformManage" */ '@/views/systems/systemPlatformLogs.vue'),
  },
  {
    path: '/systems/platformRoleManage',
    name: 'platformRoleManage',
    component: () => import(/* webpackChunkName: "platformRoleManage" */ '@/views/systems/platformRoleManage.vue'),
  },
  {
    path: '/systems/platformUserManage',
    name: 'platformUserManage',
    component: () => import(/* webpackChunkName: "platformUserManage" */ '@/views/systems/platformUserManage.vue'),
  },
  {
    path: '/systems/systemNavManage',
    name: 'systemNavManage',
    component: () => import(/* webpackChunkName: "gameNavManage" */ '@/views/systems/systemNavManage.vue')
  },
  {
    path: '/systems/systemLogs',
    name: 'systemLogs',
    component: () => import(/* webpackChunkName: "systemLogs" */ '@/views/systems/systemLogs.vue')
  },
  {
    path: '/systems/systemParams',
    name: 'systemParams',
    component: () => import(/* webpackChunkName: "systemParams" */ '@/views/systems/systemParams.vue')
  },
  {
    path: '/systems/systemAppUpdateManage',
    name: 'systemAppUpdateManage',
    component: () => import(/* webpackChunkName: "systemAppUpdateManage" */ '@/views/systems/systemAppUpdateManage.vue')
  },
  {
    path: '/systems/systemServerUpdateManage',
    name: 'systemServerUpdateManage',
    component: () => import(/* webpackChunkName: "systemServerUpdateManage" */ '@/views/systems/systemServerUpdateManage.vue')
  },
  {
    path: '/systems/systemWhiteSetting',
    name: 'systemWhiteSetting',
    component: () => import(/* webpackChunkName: "systemWhiteSetting" */ '@/views/systems/systemWhiteSetting.vue')
  },
  {
    path: '/systems/systemSensitiveWord',
    name: 'systemSensitiveWord',
    component: () => import(/* webpackChunkName: "systemSensitiveWord" */ '@/views/systems/systemSensitiveWord.vue')
  },
  {
    path: '/systems/systemResourceOss',
    name: 'systemResourceOss',
    component: () => import(/* webpackChunkName: "systemSensitiveWord" */ '@/views/systems/systemResourceOss.vue')
  },
  {
    path: '/systems/systemThirdPartySyncInfo',
    name: 'systemThirdPartySyncInfo',
    component: () => import(/* webpackChunkName: "systemThirdPartySyncInfo" */ '@/views/systems/systemThirdPartySyncInfo.vue')
  },
  {
    path: '/systems/systemThirdPartyAmountVerification',
    name: 'systemThirdPartyAmountVerification',
    component: () => import(/* webpackChunkName: "systemThirdPartyAmountVerification" */ '@/views/systems/systemThirdPartyAmountVerification.vue')
  },
  {
    path: '/systems/systemThirdPartyReconciliation',
    name: 'systemThirdPartyReconciliation',
    component: () => import(/* webpackChunkName: "systemThirdPartyReconciliation" */ '@/views/systems/systemThirdPartyReconciliation.vue')
  },
  {
    path: '/systems/systemDictManage',
    name: 'systemDictManage',
    component: () => import(/* webpackChunkName: "systemDictManage" */ '@/views/systems/systemDictManage.vue')
  },
  {
    path: '/operation/lineSet',
    name: 'operationLineSet',
    component: () => import(/* webpackChunkName: "operationLineSet" */ '@/views/operation/lineSet.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue')
  },
  {
    path: '/notAuthority',
    name: 'notAuthority',
    component: () => import(/* webpackChunkName: "notAuthority" */ '@/views/notAuthority.vue')
  },
  {
    path: '/activity/activityMsg',
    name: 'activityMsg',
    component: () => import(/* webpackChunkName: "activityMsg" */ '@/views/activity/activityMsg.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
let language = getStorage('language') || 'zh'
router.beforeEach((to, from, next) => {
  if (to.name != 'login') {
    if (!getStorage('token') && !getStorage('error')) {
      window.location.href = "/login";
    } else {
      if (to.name == 'home' || to.name == '404' || to.name == 'mineUserInfo' || to.name == 'notAuthority') {
        next()
      } else {
        let allNavList = getStorage('allNavList')
        let btn = false; // 是否有权限访问该页面
        if (allNavList && allNavList.length > 0) {
          allNavList.map(item => {
            if (to.path == item.path) {
              btn = true
            }
          })
        }
        if (btn) {
          next()
        } else {
          router.push({
            path: '/404'
          })
        }
      }
    }
  } else {
    next()
  }
  document.title = titleList[to.name] ? titleList[to.name][language] : '404';

})

export default router
